import React, { useCallback } from 'react';
import useNumberOfMembersWithAccess from 'hooks/useNumberOfMembersWithAccess';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils, { getNodeSize } from 'utils';
import usePastTime from 'hooks/usePastTime';

const useNodeInfo = (showMemberAccess = true) => {
  const pastTime = usePastTime();

  const getNumberOfMembersWithAccessCopy = useNumberOfMembersWithAccess();

  return useCallback(
    // `accessCopy` takes the member count's place.
    (node: DataRoomNode, accessCopy?: string) => {
      const { numberOfMembersWithAccess, createdAt } = node || {};

      const nodeSize = getNodeSize(node);

      return (
        <p className="node-info">
          {showMemberAccess &&
            (accessCopy ||
              getNumberOfMembersWithAccessCopy(numberOfMembersWithAccess))}

          {!!nodeSize && (
            <>
              {showMemberAccess && <span className="dot" />}
              {utils.humanizeFileSize(nodeSize)}
            </>
          )}

          <span className="dot" />

          {pastTime(createdAt)}
        </p>
      );
    },
    [showMemberAccess, getNumberOfMembersWithAccessCopy, pastTime],
  );
};

export default useNodeInfo;
